import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { conditions } from "../../../../../helpers";
import { ConditionName, IUnlockIconProps } from "../../../../../interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'

const UnlockIcon = (props: IUnlockIconProps) => {

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i className={`fa-solid pl-text-white fa-lock-open pl-cursor-pointer ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"}`} {...props}/>
            ) : (
                <Image
                    src={IMAGES.unlock}
                    alt="unlock-icon"
                    className="pl-cursor-pointer"
                    width={conditions(ConditionName.isMiniPlayer) ? 13 : 22}
                    height={conditions(ConditionName.isMiniPlayer) ? 14 : 22}
                    {...props}
                />
            )}
        </>

    )
}

export default UnlockIcon;